import { User } from 'core/application/account/loginUser'

export const loadPendo = (user: User) => {
  //@ts-ignore
  pendo.initialize({
    visitor: {
      id: user.companyUserId, // Required if user is logged in, default creates anonymous ID
      email: user.email, // Recommended if using Pendo Feedback, or NPS Email
      firstName: user.firstName,
      lastName: user.lastName,
      // role:         // Optional

      // You can add any additional visitor level key-values here,
      // as long as it's not one of the above reserved names.
    },

    account: {
      id: user.companyId, // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
      companyName: user.companyName,
      companyZipCode: user.companyZipCode,
      // monthly_value:// Recommended if using Pendo Feedback
      // planLevel:    // Optional
      // planPrice:    // Optional
      // creationDate: // Optional

      // You can add any additional account level key-values here,
      // as long as it's not one of the above reserved names.
    },
  })
}
